import { createAsyncThunk } from '@reduxjs/toolkit'
import { Dispatch } from 'redux'
import { redirect } from 'redux-first-router'

import { SharedState } from '../redux/sharedState'
import {
  filterEmptyValues,
  FilterEndpoint,
  filtersSlice,
  removeInvalidFilters,
} from './filter.reducers'
import { FilterMap } from './utils'

export const {
  resetFiltersAction,
  toggleSidebarFiltersAction,
  updateSearchFilterAction,
  updateSingleFilterAction,
} = filtersSlice.actions

const { updateFiltersAction } = filtersSlice.actions

export const updateFiltersThunk = createAsyncThunk<
  void,
  { endpoint: FilterEndpoint; filters: FilterMap },
  { dispatch: Dispatch; state: SharedState }
>(
  'filters/updateFilters',
  async ({ endpoint, filters }, { dispatch, getState }) => {
    const state: SharedState = getState()
    const {
      filters: { isInitialised },
      location: { payload },
    } = state

    const sanitizedFilters = removeInvalidFilters(endpoint)(filters)

    dispatch(
      updateFiltersAction({
        endpoint,
        filters: sanitizedFilters,
      }),
    )

    if (!isInitialised) return

    // Update URL to include filters
    // Redirect prevents filter changes from being added to history
    dispatch(
      redirect({
        payload,
        query: filterEmptyValues({
          ...(payload.query || {}),
          ...sanitizedFilters,
        }),
        type: endpoint,
      }),
    )
  },
)

export const switchContextThunk = createAsyncThunk<
  void,
  { redirectTo?: string },
  { dispatch: Dispatch; state: SharedState }
>('filters/switchContext', async ({ redirectTo }, { dispatch, getState }) => {
  dispatch(resetFiltersAction())

  const state: SharedState = getState()
  const {
    location: { payload, type },
    // eslint-disable-next-line sort-destructure-keys/sort-destructure-keys
    filters: { [type as FilterEndpoint]: endpoint },
  } = state

  // Update URL to include filters
  // Redirect prevents filter changes from being added to history
  // And you can override the redirect to the same page where it makes no sense
  // like in OrderDetails or ProductDetails where the ID may not exist in a different Context
  dispatch(
    redirect({
      payload,
      query: {
        page: '1',
        sort: endpoint?.sort,
      },
      type: redirectTo ?? type,
    }),
  )
})
